import { imageCarousel } from '@mage-ui/styled-system/recipes';

export const ImageCarousel = ({ src, alt, sizes }) => {
	if (src === undefined) {
		return null;
	}

	return (
		<img
			src={src}
			alt={alt}
			width={sizes.width}
			height={sizes.height}
			className={imageCarousel()}
		/>
	);
};
